import { v4 as uuid } from 'uuid';
import { isEmpty, set, get, isNil, cloneDeep } from 'lodash';
import { removeBannersPerPlan } from '../../../utils/defaults';
import {
    apiGetButtons,
    apiAddWidget,
    apiEditWidgets,
    apiDeleteWidgets,
    apiGetSubscribersByWidget, // eslint-disable-line no-unused-vars
    apiGetSubscribersByEventDisplay, // eslint-disable-line no-unused-vars
} from './api';

export async function getButtons (type = 'button') {
    this.env.errorStore.action = 'getButtons';
    const publisher = this.env.userStore.publisher;
    const res = await apiGetButtons({
        type: type,
        token: publisher.token,
        traceId: this.env.traceId,
        page: this.pageInfo.page + 1,
        pageLimit: this.pageInfo.limit,
    });
    let respButtonSubscribers = [];
    let respEventSubscribers = [];

    // TODO: NEEDED ON LOCAL TEST
    /*
    this.buttons = res.data.data.getWidgets.edges.map(edge => edge.node);
    this.pageInfo.count = res.data.data.getWidgets.totalCount;
    this.observed.buttons = uuid();
    */

    // TODO: COMMENT ON LOCAL_TEST
   
    if (type !== 'event') {
        respButtonSubscribers = await apiGetSubscribersByWidget({
            token: publisher.token,
            traceId: this.env.traceId,
        });
    } else {
        respEventSubscribers = await apiGetSubscribersByEventDisplay({
            token: publisher.token,
            traceId: this.env.traceId,
        });
    }

    if (res.data && res.data.data) {
        if (respButtonSubscribers.data && respButtonSubscribers.data.data) {
            this.buttons = processList(res.data.data.getWidgets.edges, respButtonSubscribers.data.data.subscribersByWidget, type);
        }
        if (respEventSubscribers.data && respEventSubscribers.data.data) {
            this.buttons = processList(res.data.data.getWidgets.edges, respEventSubscribers.data.data.subscribersByEventDisplay, type);
        }
        this.pageInfo.count = res.data.data.getWidgets.totalCount;
        this.observed.buttons = uuid();
    } else {
        // handle error.
    }

}

function injectDefaultLogoProps (style) {
    if (style) {
        if (!Object.hasOwn(style, 'logoShadow')) {
          style.logoShadow = false;
        }

        if (!Object.hasOwn(style, 'logoShape')) {
           style.logoShape = 'rect';
        }

        if (!Object.hasOwn(style, 'logoTransparent')) {
            style.logoTransparent = false;
        }
    }
}

function processList (list, subscribersByWidget, type) {
    const subscribersByWidgetObject = subscribersByWidget;
    return list.map((edge) => {
        const matchingItem = subscribersByWidgetObject?.find(item => item.id === edge.node.id);
        edge.node.subscribers = matchingItem?.count ? matchingItem.count : 0;
        if (type === 'event') {
            edge.node.embed.html = edge.node.embed?.event_display?.html;
            edge.node.embed.js = edge.node.embed?.event_display?.js;
            injectDefaultLogoProps(edge.node.style);
        } else {
            edge.node.embed.html = edge.node.embed?.button?.html;
            edge.node.embed.js = edge.node.embed?.button?.js;

            if (edge.node.embed.js.indexOf('EcalWidget') !== -1) {
                edge.node.version = '1';

                const node = edge.node;
                if (isEmpty(node.style.bannerType)) {
                    edge.node.style.bannerType = 'solid';
                }

                if (isEmpty(node.style.bannerColour)) {
                    edge.node.style.bannerColour = node.style.secondaryColour;
                }
            } else {
                edge.node.version = '2';
            }
        }

        if (typeof edge.node.style?.logoShadow !== 'boolean') {
            edge.node.style.logoShadow = false;
        }

        if (typeof edge.node.style?.logoTransparent !== 'boolean') {
            edge.node.style.logoTransparent = false;
        }

        return edge.node;
    });
}

export async function uploadWidgetAssets ({ file, assetType }) {
    this.env.errorStore.action = 'uploadWidgetAssets';
    function getRemoteAssetType () {
        if (assetType === 'buttonBanner') {
            return 'buttonLogo';
        }
        return assetType;
    }

    const res = await this.env.userStore.uploadAssets({
        file,
        assetType: getRemoteAssetType(),
    });
    this.assets[assetType] = res.data.data;
    this.observed.assets = {
        ...this.observed.assets,
        [assetType]: uuid(),
    };
}

export async function generateImage (widget, options = {}) {
    let opts = options;
    if (isEmpty(opts)) {
        opts = { textMatrix: 'matrix(1 0 0 1 58.5319 28.4999)' };
    }

    this.env.errorStore.action = 'generateButtonImage';
    const svgData = await this.env.userStore.generateSVG({
        width: widget.display.width,
        text: widget.display.text,
        buttonColour: widget.style.backgroundColour,
        fontColour: widget.style.fontColour,
        template: widget.style.template || 'ecal-round', // ecal-round, ecal-pill, ecal-square, ecal-icon
        theme: widget.style.theme || 'purple',
        textMatrix: opts.textMatrix || 'matrix(1 0 0 1 58.5319 28.4999)',
    });

    return svgData.data.url;
}

export async function addWidget (widget, options) {
    this.env.errorStore.action = 'addWidget';
    const publisher = this.env.userStore.publisher;
    this.observed.buttonsLoading = true;

    if (widget.version) {
        delete widget.version;
    }

    if (widget.type === 'button') {
        widget.image = await this.generateImage(widget, options);
    }

    removeBannersPerPlan(publisher, widget);

    await apiAddWidget({
        token: publisher.token,
        traceId: this.env.traceId,
        widget: {
            ...widget,
            display: sanitizeWidgetDisplay(widget.display),
            subscriberData: sanitizeSubscriberData(widget.subscriberData),
            settings: sanitizeWidgetSettings(widget, publisher),
            style: sanitizeStyle(widget.style, widget.type),
        },
    });

    let event = 'Created button display';
    if (widget.type === 'ad') {
        event = 'Created ad display';
    } else if (widget.type === 'event') {
        event = 'Created event display';
    }

    const metadata = {
        display_name: widget.name,
        type: widget.type,
        ip: this.env.userStore.IP || '',
    };

    window.Intercom(
        'trackEvent',
        event,
        metadata);

    this.env.history.push('/admin/displays/' + widget.type);
}

function sanitizeSubscriberData (subscriberData) {
    console.log('');
    console.log('');
    console.log('');
    console.log('sanitizeSubscriberData(): ', subscriberData);

    if (!subscriberData || isEmpty(subscriberData)) {
        return {};
    }

    const registrationFields = {
        ...subscriberData.registrationFields,
        requiredAgeValue: subscriberData.registrationFields.requiredAgeValue === '' ? 0 : subscriberData.registrationFields.requiredAgeValue,
        parentConsentAgeValue: subscriberData.registrationFields.parentConsentAgeValue === '' ? 0 : subscriberData.registrationFields.parentConsentAgeValue,
    };

    console.log('Registration Field to Send: ', registrationFields);
    const customFields = subscriberData.customFields.map((item) => {
        return {
            ...item,
            modified: undefined,
        };
    });

    return {
        registrationFields,
        customFields,
    };
}

function sanitizeWidgetData (widgets, publisher) {
    return widgets.map(item => {
        const widget = {
            ...item,
            display: sanitizeWidgetDisplay(item.display),
            subscriberData: sanitizeSubscriberData(item.subscriberData),
            settings: sanitizeWidgetSettings(item, publisher),
            style: sanitizeStyle(item.style, item.type),
            created: undefined,
            modified: undefined,
            template: undefined,
            subscribers: undefined,
            version: undefined,
        };
        // TODO remove this temporary fix for backend..
        removeBannersPerPlan(publisher, widget);
        return widget;
    });
}

export async function editWidget (widget, options) {
    // widget.display?.categories?.push('Uncategorized');
    console.log(' ', widget);
    console.log('Edit Widget: ', widget);
    if (widget.type === 'button') {
        const image = await this.generateImage(widget, options);
        widget.image = image;
    }

    this.editWidgets([widget], true, widget.type);
}

export async function editWidgets (widgets, navigateToList = true, type = 'button') {
    this.env.errorStore.action = 'editWidgets'; // use the query as the action to retrieve error from query
    console.log('');
    console.log('');
    console.log('editWidgets(): ', widgets);
    this.observed.buttonsLoading = true;
    const publisher = this.env.userStore.publisher;
    const res = await apiEditWidgets({
        token: publisher.token,
        traceId: this.env.traceId,
        widgets: sanitizeWidgetData(widgets, publisher),
    });

    console.log('Button Response: ', res);
    if (navigateToList) {
        if (type) {
            this.env.history.push('/admin/displays/' + type);
        } else {
            this.env.history.push('/admin/displays');
        }
    } else {
        this.getButtons(type);
    }
}

export async function makeWidgetsDraft (widgets, type = 'button') {
    this.observed.buttonsLoading = true;
    const drafted = widgets.map((item) => {
        console.log('creating draft: ', item);
        return {
            id: item,
            draft: true,
            type,
        };
    });
    this.editWidgets(drafted, false, type);
}

export async function makeWidgetsLive (widgets, type = 'button') {
    this.observed.buttonsLoading = true;
    const live = widgets.map((item) => {
        return {
            id: item,
            draft: false,
            type,
        };
    });
    this.editWidgets(live, false, type);
}

export async function deleteWidgets (widgets, type = 'button') {
    this.env.errorStore.action = 'deleteWidgets';
    console.log('deleteWidgets()');
    this.observed.buttonsLoading = true;
    const publisher = this.env.userStore.publisher;
    await apiDeleteWidgets({
        token: publisher.token,
        traceId: this.env.traceId,
        widgets,
        type,
    });
    this.getButtons(type);
}

export function updateSchedulesFilterForButton (res) {
    console.log('');
    console.log('');
    console.log('updateSchedulesFilterForButton()', res.data.data.getSchedules);
    if (res.data &&
        res.data.data &&
        res.data.data.getSchedules) {
        const edges = res.data.data.getSchedules.edges;
        this.buttonSchedules = edges.map(item => ({
            value: item.node.id,
            label: item.node.name,
            catName: item.node.categoryNames,
            isChild: item.node.isChild,
        }));

        console.log('Schedules filter: ', this.buttonSchedules);
        this.observed.buttonSchedules = uuid();
    }
}

function sanitizeWidgetDisplay (display) {
    const newDisplay = { ...display };
    // remove Uncategorized.... sanitize categories from old data...
    if (newDisplay.categories) {
        newDisplay.categories = newDisplay.categories.filter(c => (c !== 'Uncategorized'));
    }
    return newDisplay;
}

function replacePublisherName (msg, publisher) {
    if (!msg) {
        return '';
    }
    let pubName = publisher.company || publisher.name;
    if (isEmpty(pubName)) {
        pubName = publisher.orgName;
    }
    const newMesssage = msg.replace('[Publisher name]', pubName);
    return newMesssage;
}

function sanitizeWidgetSettings (widget, publisher) {
    const oldSettings = widget.settings;
    const newSettings = { ...oldSettings };

    if (newSettings.sharing) {
        newSettings.sharing.message = replacePublisherName(newSettings.sharing.message, publisher);
    }

    if (newSettings.welcomeMessage) {
        newSettings.welcomeMessage.message = replacePublisherName(newSettings.welcomeMessage.message, publisher);
        newSettings.welcomeMessage.title = replacePublisherName(newSettings.welcomeMessage.title, publisher);
    }

    return newSettings;
}

function trimColor (styleObj, colorProp) {
    if (isNil(styleObj)) return;
    let color = get(styleObj, colorProp);
    if (isNil(color)) return;
    color = color.trim();
    set(styleObj, colorProp, color);
}

function getPublisherLogoURL () {
    const urls = {
        local: '',
        prod: 'https://svc.ecal.com',
        stage: 'https://stage-svc.ecal.com',
        dev: 'https://test-svc.ecal.com',
    };
    // full url -> https://svc.ecal.com/v4/publishers/logo/image

    let url = urls.prod;
    if (urls[window.env]) {
        url = urls[window.env];
    }

    return `${url}/v4/publishers/logo/image`;
}

function sanitizeStyle (style, type) {
    const finalStyle = cloneDeep(style);
    // color of the syncDisplay buttons
    trimColor(finalStyle, 'bannerColour');
    trimColor(finalStyle, 'secondaryColour');
    trimColor(finalStyle, 'headingColour');
    trimColor(finalStyle, 'backgroundColour');
    trimColor(finalStyle, 'fontColour');

    // Save the publisher Logo URL but with the Environment
    if (!isEmpty(finalStyle) && !isEmpty(finalStyle.logo)) {
        if (finalStyle.logo.includes('data:image/png;base64') ||
            finalStyle.logo.includes('cropped-ecal-logo.png') || // an even older url that doesn't exist anymore
            finalStyle.logo.includes('v4/publishers/logo/image')
        ) {
            finalStyle.logo = getPublisherLogoURL();
        }
    }

    return finalStyle;
}
